module.exports = __webpack_public_path__ + "img/pr-9.4d867a23.png";